

















import Vue from "vue";
import iwAccordion from "@/encoding/components/Accordion.vue";
import iwHabitableUnitCount from "./HabitableUnitCount.vue";
import iwInputCheckbox from "@/encoding/components/buildingBlocks/InputCheckbox.vue";
import { mapActions } from "vuex";

export default Vue.extend({
    components: {
        iwAccordion: iwAccordion,
        iwHabitableUnitCount: iwHabitableUnitCount,
        iwInputCheckbox: iwInputCheckbox,
    },

    data: function() {
        return {
            pathInStoreUI: "property.hasDwellings",
            pathInStoreHabitableUnitCount: "property.livingDescription.habitableUnitCount",
        };
    },

    computed: {
        isDisplayed: function(): boolean {
            return ["HOUSE", "APARTMENT", "OTHER"].indexOf(this.getPropertyType()) !== - 1;
        },

        habitableUnitCount: function(): number | null {
            return this.$store.getters["FormModule/getValue"](this.pathInStoreHabitableUnitCount);
        },

        habitableUnitCountInput: function(): Vue {
            return (this.$refs.habitableUnitCount as Vue).$refs.habitableUnitCountInput as Vue;
        },

        hasDwellings: {
            get: function(): boolean {
                return this.$store.getters["FormModule/getValueUI"](this.pathInStoreUI);
            },

            set: function(value: boolean) {
                this.$store.commit("FormModule/addValueUI", {
                    path: this.pathInStoreUI,
                    value: value,
                });

                if (value) {
                    // Make sure count is at least 1 when checked.
                    if (!this.habitableUnitCount) {
                        this.$store.dispatch("FormModule/addValue", {
                            path: this.pathInStoreHabitableUnitCount,
                            value: 1,
                        });

                        this.habitableUnitCountInput.$data.internalValue = 1;
                    }
                } else {
                    // Remove count when unchecked.
                    this.deleteValuePath(this.pathInStoreHabitableUnitCount);
                }
            },
        },
    },

    created: function() {
        this.hasDwellings = Boolean(this.habitableUnitCount);
    },

    methods: {
        ...mapActions({
            deleteValuePath: "FormModule/deleteValuePath",
        }),
    }
});

